import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Copy, Send } from "lucide-react";
import { toast } from "sonner";
import api, { BRAND } from "@/lib/api";

const render = (tmpl, bill) => {
  if (!bill || !tmpl) return "";
  const map = {
    customer_name: bill.customer_name,
    bill_number: bill.bill_number,
    grand_total: bill.grand_total,
    balance: bill.balance,
    order_date: bill.order_date,
    delivery_date: bill.delivery_date,
    public_link: `${window.location.origin}/bill/${bill.bill_number}`,
    business_phone: BRAND.phone,
  };
  let out = tmpl;
  Object.keys(map).forEach((k) => { out = out.replaceAll(`{${k}}`, map[k]); });
  return out;
};

const TITLES = {
  bill_whatsapp: "Share Bill on WhatsApp",
  ready_for_delivery: "Send 'Order Ready' Message",
  pickup_confirm: "Send Pickup Confirmation",
  pickup_query: "Send Query Reply",
};

const WhatsAppShareDialog = ({ open, onOpenChange, bill, templateKey = "bill_whatsapp" }) => {
  const [msg, setMsg] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!bill || !open) return;
    setLoaded(false);
    api.get("/settings/messages")
      .then((r) => {
        const tmpl = r.data.templates[templateKey] || r.data.defaults[templateKey];
        setMsg(render(tmpl, bill));
        setLoaded(true);
      })
      .catch(() => { setMsg(""); setLoaded(true); });
  }, [bill, open, templateKey]);

  const copy = async () => {
    await navigator.clipboard.writeText(msg);
    toast.success("Message copied to clipboard");
  };

  const openWA = () => {
    const mobile = bill?.mobile?.replace(/\D/g, "");
    const full = mobile?.length === 10 ? `91${mobile}` : mobile;
    const url = `https://wa.me/${full || ""}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="wa-share-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Poppins" }}>{TITLES[templateKey] || "Send WhatsApp Message"}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">Edit the message below before sending. Manage the master template in <b>Messages</b>.</p>
        <Textarea
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          rows={12}
          className="font-mono text-sm"
          data-testid="wa-message-textarea"
        />
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={copy} disabled={!loaded} data-testid="wa-copy-btn"><Copy size={16} className="mr-2"/>Copy Message</Button>
          <Button onClick={openWA} disabled={!loaded} className="bg-[#25D366] hover:bg-[#1EBE5D]" data-testid="wa-open-btn"><Send size={16} className="mr-2"/>Open WhatsApp</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppShareDialog;
